/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Action_BlockInputs */



/**
* | output |
* | --- |
* | "Create audit log and block request" |
*
* @param {Compliance_Template_Action_BlockInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_action_block = /** @type {((inputs?: Compliance_Template_Action_BlockInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Action_BlockInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfprotokoll erstellen und Anfrage blockieren")
	return /** @type {LocalizedString} */ ("Create audit log and block request")
});